module.exports = __webpack_public_path__ + "img/card2_min.67ceca78.png";